import React from 'react';
import { GraduationDay2025 } from '../views';

const AccountGeneralPage = () => {
  return <GraduationDay2025/>;
};

export default AccountGeneralPage;